import * as React from "react";
import PlusIcon from "@velaro/velaro-shared/src/svg/stroke-icons/plus.svg?react";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-shared/src/components/Buttons/Buttons";
export default function NewWorkflowButton() {
  const navigate = useNavigate();
  return (
    <>
      <PrimaryBlueButton
        prefixIcon={<PlusIcon />}
        onClick={() => navigate("create")}
        label="Create Workflow"
      />
    </>
  );
}
